<template>
    <div class="section__title__box">
        <h4 class="title">User Management</h4>
        <div class="rlms-table-filters">
            <div class="rlms-tf-actions">
                <div class="input-icon-group input-icon-right">
                    <input type="search" placeholder="Search..." v-model.trim="search" @input="handleSearch">
                    <img class="rlms-input-icon" src="@/assets/images/search.svg">
                </div>
            </div>
        </div>
    </div>
    <div class="rlms-table" style="width: 100%;">
        <div class="rlms-table-inner">
            <table>
                <thead>
                    <tr>
                        <th>User ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Last access</th>
                        <th>Date</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="users?.length > 0">
                        <tr v-for="user in users" :key="user?.id">
                            <td>#{{ user?.id }}</td>
                            <td>
                                <div class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc">
                                    <img :src="`${user?.profile_picture ? storageLink + user.profile_picture : userIconPlaceholder}`"
                                        width="50" />
                                    <p class="rlms-fw-500">{{ user?.name }}</p>
                                </div>
                            </td>
                            <td>{{ user?.email }}</td>
                            <td>{{ user?.last_access ? formatDate(user?.last_access, 'DD MMM, YYYY HH:mm:ss') : 'Never' }}</td>
                            <td>{{ formatDate(user?.created_at) }}</td>
                            <td>
                                <div class="action__tab">
                                    <div class="action__btn">
                                        <RouterLink :to="`/admin/users/${user?.id}`" class="">
                                            <span class="btn__text">View</span>
                                            <span class="btn__arrow">
                                                <img src="@/assets/images/arrow-right.svg" alt="Arrow">
                                            </span>
                                        </RouterLink>
                                    </div>
                                </div>
                            </td>

                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td colspan="8">
                                <div class="rlms-flex rlms-flex-col rlms-gap-30 rlms-text-center">
                                    <img :src="noAssessmentsImg" class="rlms-mx-auto" style="width: 100px">
                                    <p v-if="search || status">No users found for the selected search or filter
                                        criteria.</p>
                                    <p v-else>No users available.</p>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
    <div class="rlms-w-100">
        <paginate v-model="page" :page-count="totalPages" :margin-pages="2" :prev-text="'<'" :next-text="'>'"
            :container-class="'pagination'" :page-class="'page-item'" :active-class="'active-page'"
            v-if="totalPages > 1" />
    </div>
</template>
<script setup>
import api from '@/services/axios';
import { useLoaderStore } from '@/stores/loader';
import { debounce } from '@/utils/debounce';
import { handleError } from '@/utils/handleError';
import { onMounted, ref, watch } from 'vue';
import paginate from 'vuejs-paginate-next';
import noAssessmentsImg from '@/assets/images/no-assessments.png';
import { formatDate } from '@/utils/format-helpers';
import userIconPlaceholder from '@/assets/images/user-placeholder.png'

const storageLink = process.env.VUE_APP_STORAGE_BASE_URL;

const page = ref(1);
const totalPages = ref(1);
const totalItems = ref(0);
const status = ref("");
const search = ref("");

const users = ref([]);
const loader = useLoaderStore();


const getUsers = async () => {
    try {
        loader.show();

        const { data } = await api.get(`admin/users`, {
            params: {
                page: page.value,
                per_page: 10,
                status: status.value,
                search: search.value,
            }
        });

        users.value = data?.data?.data || [];

        totalPages.value = data?.data?.last_page ?? 1;
        totalItems.value = data?.data?.total ?? 0;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

onMounted(async () => await getUsers());

watch(page, () => getUsers());

watch([status], () => {
    page.value = 1
    getUsers()
});

const handleSearch = debounce(function () {
    page.value = 1;
    getUsers();
}, 400);

</script>